<template>
    <b-form-group
        v-bind="propertiesWithoutDefaultValue"
        :description="description"
        :invalid-feedback="invalidFeedback"
        :label="label"
        :label-align="labelAlign"
        :label-class="labelFontWeight ? `font-weight-${labelFontWeight}` : ''"
        :label-cols="labelCols"
        :state="state"
        :valid-feedback="validFeedback"
    >
        <template v-slot:description>
            <slot name="description" />
        </template>

        <template v-slot:invalid-feedback>
            <slot name="invalid-feedback" />
        </template>

        <template v-slot:label>
            <slot name="label" />
        </template>

        <template v-slot:valid-feedback>
            <slot name="valid-feedback" />
        </template>

        <slot />
    </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'

export default {
    components: { BFormGroup },
    props: {
        description: { type: String },
        invalidFeedback: { type: String },
        label: { type: String },
        labelAlign: { type: String },
        labelCols: { type: [Boolean, Number, String], default: null },
        labelFontWeight: { type: String },
        labelFor: { type: [Number, String] },
        state: { type: Boolean, default: null },
        validFeedback: { type: String },
    },
    computed: {
        propertiesWithoutDefaultValue() {

            const props = {}

            if (this.labelFor) {

                props['label-for'] = this.labelFor
            }

            return props
        }
    }
}
</script>